import axios from 'axios';
import { resolveTimrApiBaseUrl } from '../shared/apiConfig';

export const apiBaseUrl = resolveTimrApiBaseUrl('web');
export const authStorageKey = 'timr.auth';

export const api = axios.create({
  baseURL: apiBaseUrl,
});

export function authHeaders(token, params) {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    ...(params ? { params } : {}),
  };
}
